// Keep in sync with the backend's `Site::DEFAULT_FREE_SITES_LIMIT`.
const DEFAULT_FREE_KEEPOS_LIMIT = 1;

// An unset env var reads as `undefined` (Number(undefined) is NaN, falls back below),
// but a blank one (e.g. `VITE_APP_FREE_KEEPOS_LIMIT=`) reads as "" and Number("") is
// 0 - which IS finite, so it would silently block every free Keepo creation. Treat
// blank the same as unset.
const rawFreeKeeposLimit = import.meta.env.VITE_APP_FREE_KEEPOS_LIMIT?.trim();
const parsedFreeKeeposLimit = rawFreeKeeposLimit ? Number(rawFreeKeeposLimit) : NaN;
const freeKeeposLimit = Number.isFinite(parsedFreeKeeposLimit)
  ? Math.max(0, parsedFreeKeeposLimit)
  : DEFAULT_FREE_KEEPOS_LIMIT;

const constants = {
  release: import.meta.env.VITE_APP_SENTRY_RELEASE,
  site: import.meta.env.VITE_APP_SITE,
  nameSite: import.meta.env.VITE_APP_SITE_NAME,
  instagram: "https://www.instagram.com/keepo.bio",
  api: import.meta.env.VITE_APP_API,
  staticBucket: import.meta.env.VITE_APP_BUCKET,
  env: import.meta.env.VITE_APP_ENV,
  mailChimpClientId: import.meta.env.VITE_APP_MAIL_CHIMP_CLIENT_ID,
  // Stripe's publishable key (test mode outside production): public, it's what Stripe.js uses in the browser
  stripePublishableKey: import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY,
  // Support chat (Chatwoot) for PLUS users. The website token is public: it's what the widget uses in the browser.
  chatwoot: {
    baseUrl: import.meta.env.VITE_APP_CHATWOOT_BASE_URL || "https://chat.tools.keepo.bio",
    websiteToken: import.meta.env.VITE_APP_CHATWOOT_WEBSITE_TOKEN || "aPnw7kyYqsBnZCGATfB4JJsY",
  },
  freeKeeposLimit,
  // Keepo Links' short domain (the API's `shortLink.domain`); a link's own `shortUrl` always has the right one
  shortDomain: import.meta.env.VITE_APP_SHORT_DOMAIN?.trim() || "kpo.bio",
  // Testing the NPS survey: "true" shows it on every visit to the Keepos list, skipping the API's rules and
  // the once-per-session limit (the answers are still saved). Never set in the deploy workflows
  npsTest: import.meta.env.VITE_APP_NPS_TEST === "true",
  features: {
    // Show/hide for list items (links, catalog, FAQ, highlights). Requires the page renderer
    // (@keepoinc/site-page-react-component >= 5.6.4) and the backend to skip items with `active: false`.
    itemVisibility: true,
  },
  price: {
    month: {
      value: "R$ 15,90",
    },
    year: {
      oldValue: "R$ 190,80",
      perMonth: "R$ 9,90",
      value: "R$ 119,90",
      discount: "37% OFF",
    },
  },
};

export default constants;
